(function(utils) {
	
	utils.pratimDodajPosaoClick = function(posaoId){
		return konto.ek.api.PratimDodajPosao(posaoId).then(function(rez){
			if (rez == true){
				utils.prikaziEkAlert('<span>Posao <b>' + posaoId + '</b> uspješno dodan na panel Pratim!</span>');
			}
			return rez;
		});	
	}
	
	utils.pratimUkloniPosaoClick = function(posaoId, sifarnik){
		return konto.ek.api.PratimUkloniPosao(posaoId).then(function(rez){
			if (rez == true){
				if (sifarnik){
					sifarnik.kontoGrid.refresh(true);
				}
				utils.prikaziEkAlert('<span>Posao <b>' + posaoId + '</b> uspješno uklonjen s panela Pratim!</span>')
			}
			return rez;
		});	
	}
	
	utils.prikaziEkAlert = function(poruka){
		$('.lbPorukaEKAlert').html(poruka);
		$('.alert.ekAlert').setVisible();
		$('.ekAlert').fadeIn(500).delay(1500).fadeOut(500);	
	}	
	
} (konto.ek.utils = {}));